(function() {

    var errorMessages = {
        emptyPostcode: 'Oops, it looks like you have not entered your postcode. Please add or enter your address manually.',
        wrongPostcode: 'Oops, it looks like we can\'t find your postcode. Please double check and update, or enter your address manually.'
    };

    var state = {
        addressType: 'lookup',
        lookupStage: 'ready'
    };

    var selectors = {
        addressList: '[data-address-list]',
        addressBox: '[data-address]',
        findAddressButton: '[data-find-address-button]',
        selectAddressFromList: '[data-select-address-box]',
        flatNumber: '[data-input-flatnumber]',
        houseNumber: '[data-input-housenumber]',
        street: '[data-input-addressline1]',
        address2: '[data-input-addressline2]',
        town: '[data-input-town]',
        county: '[data-input-county]',
        enterManuallyLink: '[data-enter-manually-link]',
        findAddressViaPostcode: '[data-find-address-link]',
        postcodeError: '[data-find-address-error]'
    };

    function setupManualAddress(event) {
        event.preventDefault();
        state.addressType = 'manual';
        toggleHouseNumberRequired();
        renderView();
    }

    function setupAddressFinder(event) {
        event.preventDefault();
        state.addressType = 'lookup';
        state.lookupStage = 'ready';
        toggleHouseNumberRequired();
        renderView();
    }

    $(document).on('change', selectors.flatNumber, function() {
        toggleHouseNumberRequired();
    });

    function toggleHouseNumberRequired() {
        if ($(selectors.flatNumber).val() !== '') {
            $(selectors.houseNumber).removeAttr('required');
        } else {
            $(selectors.houseNumber).attr('required', 'required');
        }
    }

    function renderView() {
        switch (state.addressType) {
            case 'lookup':
                $(selectors.enterManuallyLink).show();
                $(selectors.findAddressViaPostcode).hide();
                $(selectors.findAddressButton).show();
                $(selectors.postcodeError).hide();

                switch (state.lookupStage) {
                    case 'ready':
                        $(selectors.addressBox).hide();
                        $(selectors.selectAddressFromList).hide();
                        break;

                    case 'populated':
                        $(selectors.selectAddressFromList).show();
                        $(selectors.addressBox).hide();
                        $(selectors.selectAddressFromList).show();
                        break;

                    case 'selected':
                        $(selectors.selectAddressFromList).hide();
                        $(selectors.addressBox).show();
                        break;

                    case 'errored':
                        $(selectors.addressList).html();
                        $(selectors.selectAddressFromList).hide();
                        $(selectors.postcodeError).show();
                        break;
                }
                break;

            case 'manual':
                $(selectors.addressBox).show();
                $(selectors.findAddressButton).hide();
                $(selectors.enterManuallyLink).hide();
                $(selectors.findAddressViaPostcode).show();
                $(selectors.selectAddressFromList).hide();
                break;
        }
    }

    $(document).on('click', selectors.findAddressButton, function(event) {
        event.preventDefault();
        updateAddressFields('', '', '', '');
        $(selectors.addressBox).hide();
        state.lookupStage = 'ready';
        renderView();

        var currentText = $('[data-input-postcode]').val();
        if (currentText.trim() === '') {
            state.lookupStage = 'errored';
            $(selectors.postcodeError).html(errorMessages.emptyPostcode);
            renderView();
        } else {
            $(selectors.spinner).removeClass('hide');
            $.get({
                url: getGeoPostcodeLookupHostname() + '/address/search',
                data: {
                    'query': currentText
                },
                success: addressLookUpResponse
            });
        }
    });

    function addressLookUpResponse(data) {
        $(selectors.spinner).addClass('hide');

        if (!Array.isArray(data) || data.length === 0) {
            state.lookupStage = 'errored';
            $(selectors.postcodeError).html(errorMessages.wrongPostcode);
        } else {
            var options = '<option>Select Address</option>';
            data.forEach(function(item) {
                options = options + '<option data-address-id="' + item.id + '">' + item.address + '</option>';
            });

            state.lookupStage = 'populated';
            $(selectors.addressList).html(options);
        }

        renderView();
    }

    function fillAddressData(data) {
        var propertyConstructArray = fetchPropertyConstructArray(data);
        var flatNumber = constructProperty(data, propertyConstructArray);
        var houseNumberValue = fetchBuildingNumberOrName(data);
        var streetValue = formatAddressItem(data.street);
        var address2Value = '';
        var townValue = formatAddressItem(data.town);
        var countyValue = formatAddressItem(data.stateRegion);

        updateAddressFields(flatNumber, houseNumberValue, streetValue, address2Value, townValue, countyValue);

        state.lookupStage = 'selected';
        renderView();
    }

    $(document).on('change', selectors.addressList, function() {
        var $selectedItem = $(this).find(':selected');
        var addressId = $selectedItem.data('address-id');

        $.get({
            url: getGeoPostcodeLookupHostname() + '/address/' + addressId,
            data: {},
            success: fillAddressData
        });
    });

    function updateAddressFields(flat, house, street, address2, town, county) {
        $(selectors.flatNumber).val(flat);
        $(selectors.houseNumber).val(house);
        $(selectors.street).val(street);
        $(selectors.address2).val(address2);
        $(selectors.town).val(town);
        $(selectors.county).val(county);
    }

    function initAddressFinder() {
        $(document).on('click', selectors.enterManuallyLink, setupManualAddress);
        $(document).on('click', selectors.findAddressViaPostcode, setupAddressFinder);

        renderView();
    }

    function getGeoPostcodeLookupHostname() {
        var postcodeLookupHostname = $(selectors.selectAddressFromList).data('geo-postcode-lookup-hostname');
        if (postcodeLookupHostname) {
            return postcodeLookupHostname.replace(/\/$/g, '');
        }

        return 'https://geo.simplifyprod.co.uk';
    }

    function formatAddressItem(item) {
        return (typeof item === 'undefined' || item === null) ? '' : item;
    }

    function fetchPropertyConstructArray(address) {
        var buildingName = ['organisation', 'subBuilding'];
        if (address['buildingNumber'] && address['buildingNumber'] !== '') {
            buildingName = ['organisation', 'subBuilding', 'buildingName'];
        }
        return buildingName;
    }

    function fetchBuildingNumberOrName(address) {
        return address['buildingNumber'] ? address['buildingNumber'] : address['buildingName'];
    }

    function constructProperty(address, fieldsToConcatenate) {
        var propertyComponents = [];
        var keys = Object.keys(address);
        keys.forEach(function(key) {
            if (fieldsToConcatenate.includes(key)) {
                if (typeof address[key] !== 'undefined' && address[key] !== null) {
                    propertyComponents.push(address[key]);
                }
            }
        });
        return propertyComponents.join(', ');
    }

    function validateNumericFields(fieldId) {
        let fieldVal = $('#' + fieldId).val();
        if (!$.isNumeric(fieldVal)) {
            $('#' + fieldId).val('');
        }
        if (fieldId == 'customer_form_bankAccountNumber') {
            if (fieldVal.length > 8) {
                $('#' + fieldId).val(fieldVal.substring(0, 8));
            }
        }
    }

    if ($('#customer_form_bankAccountNumber').length) {
        $('#customer_form_bankAccountNumber').attr('maxlength', 8);
        $('#customer_form_bankAccountNumber').attr('minlength', 8);
        $(document).on('focus', '#customer_form_bankAccountNumber, #customer_form_sortCode, #customer_form_mobileNumber', function() {
            $(this).attr('inputmode', 'numeric');
            $(this).attr('_originaltype', 'number');
        });
        $(document).bind('input propertychange', '#customer_form_mobileNumber', function() {
            validateNumericFields('customer_form_mobileNumber');
        });
        $(document).bind('input propertychange', '#customer_form_bankAccountNumber', function() {
            validateNumericFields('customer_form_bankAccountNumber');
        });
        $(document).bind('input propertychange', '#customer_form_sortCode', function() {
            validateNumericFields('customer_form_sortCode');
        });
    }

    initAddressFinder();

})($);
